// extracted by mini-css-extract-plugin
module.exports = {"container":"StatisticsSelectionByType_container__A08RE","option":"StatisticsSelectionByType_option__2_t0k"};